<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_iv"></a><strong>Capitalism 3.0</strong></p>
<p class="copy"><strong>Copyright © 2006 by Peter Barnes</strong></p>
<p class="copy1">All commercial rights reserved. No part of this publication may be reproduced, distributed, or transmitted for commercial purposes without the prior written permission of the publisher. Brief quotations for use in reviews may be cited without permission. In addition, an electronic downloadable version is available free of charge at <a class="nounder" href="http://www.onthecommons.org" target="_blank">http://www.onthecommons.org</a>, and may be distributed for noncommercial purposes without permission, provided the work is attributed to the author and no derivative works are made from it. This electronic version is licensed under the Creative Commons Attribution-NonCommercial-NoDerivs 2.5 License (some restrictions apply). To view a copy of this license, visit <a class="nounder" href="http://creativecommons.or/licenses/by-nc-nd/2.5/" target="_blank">http://creativecommons.or/licenses/by-nc-nd/2.5/</a>. For permission requests, write to the publisher, addressed “Attention: Permissions Coordinator,” at the address below.</p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="10%"/>
<col width="90%"/>
</colgroup><tbody><tr>
<th></th>
</tr>
<tr>
<td valign="top">
<p class="copyrighti"><img alt="image" src="Images/copy.jpg"/></p>
</td>
<td valign="top">
<p class="copyrighti"><strong>Berrett-Koehler Publishers, Inc.</strong><br/>
        235 Montgomery Street, Suite 650<br/>
        San Francisco, California 94104-2916<br/>
        Tel: (415) 288-0260, Fax: (415) 362-2512<br/>
<a class="nounder" href="http://www.bkconnection.com" target="_blank">www.bkconnection.com</a></p>
</td>
</tr>
</tbody></table>
<p class="copy"><strong>Ordering information for print editions</strong></p>
<p class="copy1"><em>Quantity sales</em>. Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the “Special Sales Department” at the Berrett-Koehler address above.</p>
<p class="copy1"><em>Individual sales</em>. Berrett-Koehler publications are available through most bookstores. They can also be ordered directly from Berrett-Koehler: Tel: (800) 929-2929; Fax: (802) 864-7626; <a class="nounder" href="http://www.bkconnection.com" target="_blank">www.bkconnection.com</a></p>
<p class="copy1"><em>Orders for college textbook/course adoption use</em>. Please contact Berrett-Koehler: Tel: (800) 929-2929; Fax: (802) 864-7626.</p>
<p class="copy1"><em>Orders by U.S. trade bookstores and wholesalers</em>. Please contact Ingram Publisher Services, Tel: (800) 509-4887; Fax: (800) 838-1149; E-mail: customer</p>
<p class="copy1">.<a class="nounder" href="mailto:service@ingrampublisherservices.com">service@ingrampublisherservices.com</a>; or visit <a class="nounder" href="http://www.ingrampublisherservices.com/" target="_blank">www.ingrampublisherservices.com/</a>Ordering for details about electronic ordering.</p>
<p class="copy">Berrett-Koehler and the BK logo are registered trademarks of Berrett-Koehler Publishers, Inc.</p>
<p class="copy">First Edition</p>
<p class="copy1">Hardcover print edition ISBN 978-1-57675-361-3</p>
<p class="copy1">PDF e-book ISBN 978-1-62656-393-3</p>
<p class="copy1">IDPF e-book ISBN 978-1-60509-164-8</p>
<p class="copy">2014-1</p>
<p class="copy">Interior Design: Laura Lind Design</p>
<p class="copy1">Proofreader: Henrietta Bensussen</p>
<p class="copy1">Copy Editor: Sandra Beris</p>
<p class="copy1">Indexer: Medea Minnich</p>
<p class="copy1">Production: Linda Jupiter, Jupiter Production</p>
<p class="copy1">Cover Design: Richard Adelson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?8c174eea